import React from "react"
import BookInfoTable from "./BookInfoTable"

const BookInformation = ({ book, isMobile, bookInLedger }) => {
  return (
    <>
      <BookInfoTable book={book} isMobile={isMobile} bookInLedger={bookInLedger} />

      {/* {bookInLedger?.status === undefined && <DialogFooterNoAction book={book} isMobile={isMobile} />} */}
    </>
  )
}

export default BookInformation
